import * as React from 'react';
import {cva, type VariantProps} from 'class-variance-authority';
import {cn} from '../lib/cn';

const framedIconVariants = cva('inline-flex items-center justify-center shrink-0', {
  variants: {
    size: {
      s: 'w-8 h-8',
      m: 'w-10 h-10',
      l: 'w-12 h-12',
    },
    shape: {
      rounded: 'rounded-[var(--chekin-radius-input)]',
      circle: 'rounded-full',
    },
    tone: {
      neutral:
        'bg-[var(--chekin-color-surface-input-empty)] text-[var(--chekin-color-gray-1)]',
      info: 'bg-[var(--chekin-color-surface-pressed)] text-[var(--chekin-color-brand-blue)]',
      success: 'bg-[var(--chekin-green-50)] text-[var(--chekin-green-700)]',
      warn: 'bg-[var(--chekin-amber-200)] text-[var(--chekin-amber-700)]',
      error: 'bg-[var(--chekin-red-150)] text-[var(--error-message-color)]',
    },
  },
  defaultVariants: {size: 'm', shape: 'rounded', tone: 'info'},
});

export interface FramedIconProps
  extends
    Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'>,
    VariantProps<typeof framedIconVariants> {
  children: React.ReactNode;
}

export const FramedIcon = React.forwardRef<HTMLSpanElement, FramedIconProps>(
  ({className, size, shape, tone, children, ...props}, ref) => (
    <span
      ref={ref}
      aria-hidden="true"
      className={cn(framedIconVariants({size, shape, tone}), className)}
      {...props}
    >
      {children}
    </span>
  ),
);
FramedIcon.displayName = 'FramedIcon';
